// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./app/assets/css/ng-animation.css
// module id = 304
// module chunks = 0